/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Wizard_Step5_MembersInputs */



/**
* | output |
* | --- |
* | "Members ({count})" |
*
* @param {Spaces_Wizard_Step5_MembersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step5_members = /** @type {((inputs: Spaces_Wizard_Step5_MembersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step5_MembersInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Mitglieder (${i?.count})`)
	return /** @type {LocalizedString} */ (`Members (${i?.count})`)
});